import { AxiosError, AxiosResponse } from "axios";
import { ValidateCodeProps } from "../../interfaces/ValidateCodeProps";
import { useAlertError } from "../../store/AlertError";
import { useGlobalLoading } from "../../store/GlobalLoading";
import { ResponseMessagesEnum } from "../../interfaces/Enums";
import { useSignUp } from "../../store/SignUp";
import { api } from "../../services/api";

export function useAuthValidateCode() {
  const { openAlert } = useAlertError();
  const { closeLoading } = useGlobalLoading();
  const { setValidationCode } = useSignUp();

  async function validateCode(body: ValidateCodeProps): Promise<boolean> {
    try {
      const response = await api.post("/email/validate", body);
      handleResponse(response);
      setValidationCode();
      closeLoading();
      return true;
    } catch (error: AxiosError | any) {
      handleError(error);
      closeLoading();
      return false;
    }
  }

  function handleResponse(response: AxiosResponse): void {
    if (response.status === 200) {
      openAlert({
        message: ResponseMessagesEnum.SuccessCode,
        status: "success",
      });
    } else {
      throw new Error(response.data.message);
    }
  }

  function handleError(error: AxiosError): void {
    const { response } = error;

    if (response) {
      openAlert({
        message: ResponseMessagesEnum.ErrorCode,
        status: "error",
      });
    }
  }

  return { validateCode };
}
